import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
// import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
// import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
// import PhoneIphoneOutlinedIcon from '@mui/icons-material/PhoneIphoneOutlined';
//import InstagramIcon from '@mui/icons-material/Instagram';
//import TwitterIcon from '@mui/icons-material/Twitter';
import Navbar from 'react-bootstrap/Navbar';
import { Link } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { FaFacebook, FaInstagramSquare } from 'react-icons/fa';
//import  from '@mui/icons-material/Facebook';
import { FaArrowCircleUp } from 'react-icons/fa';

export default function Footer() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300) {
      setVisible(true);
    } else if (scrolled <= 300) {
      setVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  window.addEventListener('scroll', toggleVisible);
  const headerImg = '../images/sipakw.png';

  return (
    <>
      <div className="container footer-space mt-5">
        <Row>
          <Col md={3}>
            <Link to="/" onClick={scrollToTop}>
              <Navbar.Brand className="brand-footer-logo">
                <span>
                  <img className="img-icon" src={headerImg} alt={headerImg} />
                </span>
                <p className="textcolor ml-8">{t('company_statement')}</p>
              </Navbar.Brand>
            </Link>

            <div></div>
          </Col>
          <Col md={3}>
            <h6 className="footer-title px-1 d-flex">Categories</h6>
            <div className="d-flex my-1 p-1">
              <i className="fa fa-minus mt-1 px-1 fa-2xs"></i>
              Architectural Systems
            </div>
            <div className="d-flex p-1 my-1">
              <i className="fa fa-minus mt-1 px-1 fa-2xs"></i>
              Standard Products
            </div>
            <div className="d-flex p-1 my-1 ">
              <i className="fa fa-minus mt-1 px-1 fa-2xs"></i>
              Composite Panels
            </div>
            <div className="d-flex p-1 my-1 ">
              <i className="fa fa-minus mt-1 px-1 fa-2xs"></i>
              Accessories Range
            </div>
          </Col>
          <Col md={3}>
            <h6 className="footer-title d-flex">{t('Contact_us')}</h6>
            <div className="d-flex my-1 p-1">
              <i className="fa fa-map-marker colorInfo  fa-lg"></i>
              العراق- بغداد -مجمع بوابة العراق السکني بنایة ٣٢ ط٦ شقة ٣٤
            </div>
            <div className="d-flex p-1 my-1">
              <i className="fa fa-envelope colorInfo fa-sm"></i>
              info@aelrafidain.com
            </div>
            <div className="d-flex p-1 my-1 ">
              <i className="fa fa-phone colorInfo fa-lg"></i>
              00964 770 087 7777
            </div>
          </Col>
          <Col></Col>
          <Col md={2}>
            {/* <h6 className=" footer-title d-flex">{t('follow_us')}</h6>
            <div className="media-footer">
              <a
                href="https://www.facebook.com/profile.php?id=100064050006762&sk=photos"
                target="_blank"
                rel="noreferrer"
              >
                <FaFacebook size={24} className="media-footer" />
              </a>
              <Link to="/">
                <FaInstagramSquare size={24} className="media-footer" />
              </Link>
            </div> */}
          </Col>
        </Row>
      </div>
      <div className="scroll-button">
        <FaArrowCircleUp
          onClick={scrollToTop}
          style={{ display: visible ? 'inline' : 'none' }}
        />
      </div>
      <div className="row-footer">
        <div className="row-line  text-center mt-5">
          <div className="footer-copy w-100">
            © 2024 Copyright: All rights reserved
          </div>
        </div>
      </div>
    </>
  );
}
